import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const DailyWesternAstrologyContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 10px;
  .horoscope-detail-content-characteristic{
    width: 100%;
    ${Font.clarinVarSub2Regular};
    font-size: 23px;
    line-height: 33px;
    text-align: center;
    h2{
      color: ${Color.black000};
      ${Font.sansBold};
      font-size: 23px;
      line-height: 28px;
      margin-top: 16px;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color:${ColorDark.textLight};
        }
      }
      ${breakpoints.phone} {
        font-size: 20px;
      }
    }   
    ul li{
      margin-top: 5px;
    } 
    ${breakpoints.phone} {
      font-size: 20px;
      text-align: left;
    }
  }
`